import { NavLink, useLocation } from 'react-router'

import { cn } from '@/lib/utils'

const tabs = [
  { to: '/eshop/delivery-methods', label: 'Doprava', also: ['/eshop/pickup-points'] },
  { to: '/eshop/payment-methods', label: 'Platby' },
  { to: '/eshop/tokens', label: 'API tokeny' },
]

/** Záložky sekce E-shop. V sidebaru je e-shop jedna položka, jednotlivé části se přepínají tady. */
export const EshopTabs = () => {
  const { pathname } = useLocation()
  return (
    <nav aria-label="E-shop" className="-mt-1 mb-6 flex gap-5 border-b">
      {tabs.map((tab) => {
        const active = pathname === tab.to || tab.also?.some((p) => pathname.startsWith(p))
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              '-mb-px border-b-2 pb-2.5 text-sm transition-colors',
              active
                ? 'border-foreground font-medium text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {tab.label}
          </NavLink>
        )
      })}
    </nav>
  )
}
